import { PropsWithChildren, useEffect } from 'react';

import { useConfidence } from '@spotify-confidence/react';
import { useAuth } from '@spotify/confidence-core-react';

import { sessionRecorder } from '../bootstrap';

export function FlagContext({ children }: PropsWithChildren) {
  const { user, isAuthenticated, orgName } = useAuth();
  const confidence = useConfidence();

  useEffect(() => {
    confidence.setContext({
      ...user,
    });
  }, [user]);

  useEffect(() => {
    if (isAuthenticated) {
      sessionRecorder?.tag('isAuthenticated', `${isAuthenticated}`);
    }
    if (orgName) {
      sessionRecorder?.tag('org_name', orgName);
    }
  }, [isAuthenticated, orgName]);

  // TODO wrap children in a ConfidenceProvider.WithContext({...user}) provider
  return <>{children}</>;
}
